import { Action } from 'redux';

export enum Types {
  SET_NAVBAR_TITLE = "SET_NAVBAR_TITLE",
  SET_VEHICLE_POLICY_DETAILS_SECTION = "SET_VEHICLE_POLICY_DETAILS_SECTION",
  SET_UPDATE_MARKET_SCAN_POPUP = "SET_UPDATE_MARKET_SCAN_POPUP"
}

export interface ISetNavBarTitle extends Action {
  type: Types.SET_NAVBAR_TITLE;
  data: string;
}


export const SetNavBarTitleAction = (data?: string) => {
  return {
    type: Types.SET_NAVBAR_TITLE,
    data,
  } as ISetNavBarTitle;
};
export interface ISetPolicyDetailsSection extends Action {
  type: Types.SET_VEHICLE_POLICY_DETAILS_SECTION;
  data: boolean;
}


export const SetPolicyDetailsSection = (data: boolean) => {
  return {
    type: Types.SET_VEHICLE_POLICY_DETAILS_SECTION,
    data
  } as ISetPolicyDetailsSection;
};

export interface ISetUpdateMarketScanPopup extends Action {
  type: Types.SET_UPDATE_MARKET_SCAN_POPUP;
  data: boolean;
}


export const SetUpdateMarketScanPopup = (data: boolean) => {
  return {
    type: Types.SET_UPDATE_MARKET_SCAN_POPUP,
    data
  } as ISetUpdateMarketScanPopup;
};

